<template>
  <BContainer
    fluid
    class="container-pages mb-3"
    v-if="items?.data && subcategory?.subcategory"
  >
    <BRow class="mb-3">
      <BCol xl="8" lg="7">
        <div class="shadow rounded p-element-page bg-white">
          <div>
            <h1 class="h1-title">
              {{ subcategory.subcategory.description }} za {{ selectYear }}
            </h1>

            <nuxt-link :to="routePath({ name: 'cena-na-pijacama' })">
              <h2 class="text-info h2-subtitle text-uppercase">
                ponuda na pijacama u Srbiji | {{ titleReplace('Cene na pijacama u Srbiji:') }}
              </h2>
            </nuxt-link>

            <hr />

            <div class="select-year mb-4 mt-3">
              <p class="font-size-12 fw-bold text-uppercase">
                Izaberi godinu:
              </p>

              <BFormSelect
                :options="years"
                v-model="selectYear"
                @change="clickSelect"
              />
            </div>
          </div>
<div class="mt-3 mb-3">

    <NuxtLink
    :key="subcategory?.subcategory?.title_path"
    :to="`/cene-istorija/${categoryHistoryPath}`"
    class="price-history-cta"
>
    <div class="price-history-cta-content">
        

        <div>
            <span class="price-history-cta-label">
                Istorija cena
            </span>

            <strong class="price-history-cta-title">
                Pogledajte istorijat
                {{ subcategory?.subcategory?.title_path.toLowerCase() }}
            </strong>
        </div>
    </div>

    <i class="esei icon-angle-right-solid"></i>
</NuxtLink>

          </div>
          <div
            class="d-flex page-price-description"
            v-if="lang === 'sr' && checkDescriptionDisplay(subcategory.subcategory.description_page)"
          >
            <div
              :class="`${btn ? 'd-none' : 'd-block'}`"
              v-html="descriptionDisplay(subcategory.subcategory.description_page, false)"
              @click="btn = !btn"
            ></div>

            <div
              :class="`${btn ? 'd-block' : 'd-none'}`"
              class="w-80"
              v-html="descriptionDisplay(subcategory.subcategory.description_page, true)"
              @click="btn = !btn"
            ></div>

            <i
              id="down-awesome"
              @click="btn = !btn"
              class="esei icon-chevron-down d-flex text-right ms-2 mt-1 font-size-20"
            ></i>
          </div>

          <div v-if="lang === 'sr' && subcategory.subcategory.text_other">
            <BAlert
              variant="info"
              class="text-center text-uppercase fw-bold"
              :model-value="true"
            >
              {{ subcategory.subcategory.text_other }}
            </BAlert>
          </div>

          <div class="a-container mb-3" v-if="$screen.showMobileAds">
            <AdsPriceMobile />
          </div>

          <div
            class="weeks-list"
            v-if="!error && items?.data && subcategory?.subcategory"
          >
            <template
              v-for="group in groupedWeeks"
              :key="group.label"
            >
              <p class="weeks-list-month">{{ group.label }}</p>

              <nuxt-link
                v-for="week in group.weeks"
                :key="week.week"
                class="weeks-list-item"
                :to="routePath({
                  name: 'cena-weeks',
                  params: { weeks: sendDescription(week).split(' ').join('-') }
                })"
              >
                <span class="weeks-list-main">
                  <span class="weeks-list-range">
                    {{ weekRange(week) }}
                    <span
                      class="weeks-list-number"
                      v-if="week.number"
                    >
                      {{ week.number }}. nedelja
                    </span>
                  </span>
                  <span
                    class="weeks-list-desc"
                    v-html="descriptionCard(week)"
                  ></span>
                </span>
                <span class="weeks-list-cta">
                  Klikni da vidiš cene
                  <i class="esei icon-angle-right-solid"></i>
                </span>
              </nuxt-link>
            </template>
          </div>

          <div class="a-container mb-3 mt-2" v-if="$screen.isProduction">
            <AdsPriceBottom />
          </div>
        </div>
      </BCol>

      <BCol xl="4" lg="5">
        <div class="a-container mb-3" v-if="$screen.showDesktopAds">
          <AdsPriceTopRight />
        </div>

        <TopAdsPages
          :items="items.data?.ad?.data"
          :category_name="''"
          :display_img="true"
        />
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { BAlert, BCol, BContainer, BFormSelect, BRow } from 'bootstrap-vue-next'
import localizationLang from '~/util/localization/localizationItemsSubcategory'
import useRangeFunction from '~/util/range/range'
import findMonthLocalization from '~/util/localization/findMonth'



import { defineAsyncComponent } from 'vue'

const AdsPriceMobile = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsPriceMobile.vue')
)

const AdsPriceBottom = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsPriceBottom.vue')
)

const AdsPriceTopRight = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsPriceTopRight.vue')
)

const TopAdsPages = defineAsyncComponent(() =>
  import('~/components/widgets/Advertisement/TopAdsPages.vue')
)


import { useStipsWeekStore } from '~/stores/stips/week'
import { useShareMetaStore } from '~/stores/shareMeta'

const useStore = useStipsWeekStore()
const shareMeta = useShareMetaStore()

const router = useRouter()
const route = useRoute()
const config = useRuntimeConfig()

const routePath = useRoutePath()

const locale = ref('sr')
const lang = computed(() => locale.value)

// godine
const { range } = useRangeFunction(2018, new Date().getFullYear())
const years = ref(range())

// UI state
const btn = ref(false)

// --- PARAMETRI IZ SLUGA (FIX) ---
const singleproductsParts = computed(() =>
  String(route.params.singleproducts || '').split('-')
)

const yearParam = computed(() => singleproductsParts.value.at(-1))
const categoryParam = computed(() => singleproductsParts.value.at(-2) || '')

// selectYear prati yearParam
const selectYear = ref(yearParam.value)
watch(yearParam, (y) => {
  selectYear.value = y
})

// subcategory uvek prati locale + route param
const subcategory = computed(() => {
  const slug = String(route.params.singleproducts || '')
  return (
    localizationLang.findLangSingleproducts(locale.value, slug) || {
      subcategory: null,
      path_sr: ''
    }
  )
})

// slug ne postoji (npr. engleski slug): 301 na početnu, bez error stranice
if (!subcategory.value.subcategory) {
  await navigateTo('/', { redirectCode: 301, replace: true })
}

const categoryHistoryPath = computed(() => {
    return subcategory.value?.subcategory?.title_path
        ?.split(' ')
        .join('-')
        .toLowerCase() ?? '';
});
// promena godine u URL-u
const clickSelect = () => {
  const slug = String(route.params.singleproducts || '')
  // menja samo poslednje 4 cifre (godinu)
  const subRoute = slug.substring(0, slug.length - 4) + String(selectYear.value)
  router.push(subRoute)
}

// fetch
const { data: items, error } = await useAsyncData(
  () => `items-${yearParam.value}`,
  () => useStore.getCacheWeeksByYearAdPublic({ year: yearParam.value }),
  {
    watch: [yearParam]
  }
)

const titleReplace = (title) => title.replace(':', '')

const descriptionDisplay = (description, expanded) =>
  !expanded ? description.substring(0, 100) + '...' : description

const checkDescriptionDisplay = (description) => (description?.length || 0) > 0

const findMonth = (week) => {
  const dot = week.week.split('.')
  return findMonthLocalization.srMonth(dot[1])
}

const srDescriptionCard = (week) =>
  `${subcategory.value.subcategory.description} za mesec ${findMonth(week)}, od ${week.week}`

const descriptionCard = srDescriptionCard

// --- redizajn liste nedelja: grupisanje po mesecu + kratak opseg datuma ---

const parseWeekDates = (week) => {
  const matches = String(week?.week || '').match(/\d{1,2}\.\d{1,2}\.\d{4}/g)
  return { start: matches?.[0] || '', end: matches?.[1] || '' }
}

const capitalize = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

const weekMonthLabel = (week) => {
  const { start } = parseWeekDates(week)
  const year = start.split('.')[2] || ''
  return `${capitalize(findMonth(week))} ${year}.`.trim()
}

const weekRange = (week) => {
  const { start, end } = parseWeekDates(week)
  const [day, month] = start.split('.')

  if (!day || !month || !end) return week?.week || ''

  return `${day}.${month} – ${end}.`
}

const groupedWeeks = computed(() => {
  const list = items.value?.data?.weeks || []
  const groups = []
  let currentLabel = null

  list.forEach((week) => {
    const label = weekMonthLabel(week)

    if (label !== currentLabel) {
      currentLabel = label
      groups.push({ label, weeks: [] })
    }

    groups[groups.length - 1].weeks.push(week)
  })

  return groups
})

const srDescription = (week) =>
  `${subcategory.value.subcategory.description_path.toLowerCase()} za mesec ${findMonth(week)} od ${week.week} ${subcategory.value.subcategory.value_path.toLowerCase()} ${categoryParam.value} ${yearParam.value}`

const sendDescription = srDescription

// title/meta
const pageTitle = computed(() => {
  if (!subcategory.value.subcategory) return ''
  const base = subcategory.value.subcategory.description
  return `${base} za ${yearParam.value}`
})

const canonical = computed(() => `${config.public.API_BASE}${route.fullPath}`)

// share meta
watchEffect(() => {
  if (!subcategory.value?.subcategory) return
  shareMeta.setMeta({
    title: pageTitle.value,
    description: subcategory.value.subcategory.description_meta,
    url: canonical.value
  })
})

// JSON-LD: CollectionPage + ItemList sa nedeljama za izabrani proizvod/godinu
const collectionLd = computed(() => {
  const sub = subcategory.value?.subcategory
  const allWeeks = items.value?.data?.weeks || []
  if (!sub) return null

  const baseUrl = config.public.API_BASE

  // Ogranicavamo na 10 nedelja u schema-i (godina ima do 52)
  const weeks = allWeeks.slice(0, 10)

  const itemListElement = weeks.map((w, idx) => {
    const slug = sendDescription(w).split(' ').join('-')
    const path = `/cena/${slug}`
    return {
      '@type': 'ListItem',
      position: idx + 1,
      item: {
        '@type': 'Thing',
        name: descriptionCard(w),
        url: `${baseUrl}${path}`
      }
    }
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${canonical.value}#collection`,
    url: canonical.value,
    name: pageTitle.value,
    description: sub.description_meta,
    inLanguage: lang.value,
    isPartOf: {
      '@type': 'WebSite',
      name: 'Pijace.com',
      url: 'https://pijace.com'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: 'https://pijace.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://pijace.com/images/pijace-60.png'
      }
    },
    ...(itemListElement.length > 0
      ? {
          mainEntity: {
            '@type': 'ItemList',
            name: `${sub.description} - nedelje za ${yearParam.value}`,
            // numberOfItems je ukupan broj nedelja, ne samo prikazanih 10
            numberOfItems: allWeeks.length,
            itemListElement
          }
        }
      : {})
  }
})

// JSON-LD: BreadcrumbList — Cena na pijacama → trenutni proizvod
const breadcrumbLd = computed(() => {
  const sub = subcategory.value?.subcategory
  if (!sub) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Cena na pijacama',
        item: 'https://pijace.com/cena-na-pijacama'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: sub.description,
        item: canonical.value
      }
    ]
  }
})

usePijaceSeo({
  title: pageTitle,
  description: () => subcategory.value?.subcategory?.description_meta ?? '',
  url: canonical,
  type: 'website',
  locale: lang,
  jsonLd: () => [collectionLd.value, breadcrumbLd.value],
})
</script>

<style>
</style>
